import * as Yup from "yup";
import { Formik } from "formik";
import EDECLogo from "../../../icons/Pictogramme_EDEC_vert.svg";
import React from "react";

const EDECForm = ({ user, updateUserForm }) => {
  const [isEditing, setIsEditing] = React.useState(false);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          id: user ? user.id : "",
          EDECUsername:
            user && user.integrations && user.integrations.edec
              ? user.integrations.edec.username
              : "",
          EDECPassword:
            user && user.integrations && user.integrations.edec
              ? user.integrations.edec.password
              : "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            setSubmitting(false);
            updateUserForm(values);
            setIsEditing(false);
          }, 500);
        }}
        validationSchema={Yup.object().shape({
          id: Yup.string(),
        })}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
          } = props;

          return (
            <form onSubmit={handleSubmit}>
              <h4 className="mb-2 d-flex align-items-center">
                <img
                  src={EDECLogo}
                  alt="EDEC logo"
                  style={{ width: 15, marginRight: 5 }}
                />
                EDEC
              </h4>
              <div className="row">
                <div className="col-12">
                  <div className="form-group has-danger">
                    <div>
                      <label htmlFor="EDECUsername">EDEC Username</label>
                      {isEditing ? (
                        <>
                          <input
                            type="text"
                            id="EDECUsername"
                            placeholder="EDEC Username"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.EDECUsername}
                          />
                          {errors.EDECUsername && touched.EDECUsername && (
                            <div className="mt-1 danger">
                              {errors.EDECUsername}
                            </div>
                          )}
                        </>
                      ) : (
                        <p className="font-weight-bold">
                          {user.integrations?.edec?.username ||
                            "Pas de nom d'utilisateur défini"}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group has-danger">
                    <div>
                      <label htmlFor="EDECPassword">EDEC Password</label>
                      {isEditing ? (
                        <>
                          <input
                            type="text"
                            id="EDECPassword"
                            placeholder="EDEC Password"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.EDECPassword}
                          />
                          {errors.EDECPassword && touched.EDECPassword && (
                            <div className="mt-1 danger">
                              {errors.EDECPassword}
                            </div>
                          )}
                        </>
                      ) : (
                        <p className="font-weight-bold">
                          {user.integrations?.edec?.password ||
                            "Pas de mot de passe défini"}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 d-flex flex-sm-row flex-column justify-content-end">
                  {isEditing ? (
                    <>
                      <button
                        type="button"
                        className="btn btn-secondary mr-1"
                        onClick={() => setIsEditing(false)}
                      >
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-primary ">
                        Enregistrer
                      </button>
                    </>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setIsEditing(true)}
                    >
                      Modifier
                      <i className="feather icon-edit-1 ml-1" />
                    </button>
                  )}
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default EDECForm;
